import { AvailableLocale } from '@models/Lang'

/**
 * The front-of-card field labels, shared by all three preview faces so Apple,
 * Google and the in-app card read identically — and matching the real sources:
 * ApplePassBuilder::localeStrings, GooglePassBuilder's text-module headers, and
 * the app's MemberCardId string. Change a label here and every face follows.
 */
export const WALLET_LABELS: Record<
  AvailableLocale,
  { member: string; cardNumber: string; expires: string }
> = {
  fr: { member: 'Membre', cardNumber: 'Numéro de carte', expires: 'Expire le' },
  en: { member: 'Member', cardNumber: 'Card number', expires: 'Expires' },
}
